import database from 'database'

export default store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'session/setSession') {
      database.UserSession.put({
        id: 1,
        company: state.session.company,
        ambito: state.session.ambito,
        current: state.session.current
      })
    }

    if (mutation.type === 'session/setCurrent') {
      database.UserSession.update(1, {
        current: state.session.current
      })
    }

    if (mutation.type === 'session/setCompany') {
      database.UserSession.update(1, {
        company: state.session.company
      })
    }

    if (mutation.type === 'session/setAmbito') {
      database.UserSession.update(1, {
        ambito: state.session.ambito
      })
    }

    if (mutation.type === 'session/reset') {
      database.UserSession.clear()
    }
  })
}
